import React from 'react'
import { animateScroll } from 'react-scroll'
import { Fab } from '@material-ui/core'
import { ArrowUpward } from '@material-ui/icons'
import useStyles from './style'

const ScrollUpButton = () => {
  const classes = useStyles()

  return (
    <Fab
      className={classes.fab}
      aria-label="uparrow"
      onClick={() => {
        animateScroll.scrollToTop({ smooth: true })
      }}
    >
      <ArrowUpward />
    </Fab>
  )
}

export default ScrollUpButton
